import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiFontsService from '@/services/banzai-fonts.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiFonts = new BanzaiFontsService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiFonts: BanzaiFontsService;
  }
}
